/**
 * Default view filter constants
 */
import type { ViewFilter, ViewFilterProps } from "building-types/views/viewFilterTypes";
import { emptyViewFilter } from "lib/studio/viewFilters";
import { internalViewFilter3DDefaults } from "../../components/studio/renderStageConstants";

const propDefaultViewFilter: ViewFilterProps = {
  propAppliances: true,
  propFixtures: true,
  propFoliage: true,
  propFurniture: true,
  propOther: true,
};

export const defaultViewFilter3DBuilding: Partial<ViewFilter> = {
  ...propDefaultViewFilter,
  flooring: true,
  floorFraming: true,
  subFlooring: true,
  slabFlooring: true,
  walls: true,
  ceilings: true,
  roofs: true,
  roofVolumes: true,
  cornerBoards: true,
  baseTrimMolding: true,
  crownTrimMolding: true,
  interiorWallPlaneTrimMolding: true,
  wainscoting: true,
  windowUnits: true,
  windowShutters: true,
  doorUnits: true,
  doorSwings: true,
  annotation: true,
  slab: true,
  stemWall: true,
  foundationCurb: true,
  foundationFooting: true,
  foundationPiers: true,
  porches: true,
  stairSystems: true,
  railings: true,
  casework: true,
  driveways: true,
  interiorLights: true,
  columns: true,
  roofFraming: false,
  roofing: false, // Excluded in Estimate and Studio
};

const baseDefaultView3DFilter: ViewFilter = {
  ...emptyViewFilter,
  ...internalViewFilter3DDefaults,
  ...defaultViewFilter3DBuilding,
  site: true,
  underlays: true,
  gradeLine: true,
  // Sections label the rooms their cut plane passes through. Only section views expose the control
  // (see `viewFilterKeyToViewType`); defaulting it on keeps the labels that sections always drew.
  roomTags: true,

  // Admin only
  crossSection: true,
};

const defaultView3DFilterInternal: ViewFilter = {
  ...baseDefaultView3DFilter,
  faceDiff: true,
  roofSideSelection: true,
  elevationAnnotation: true,
};

export const defaultShowroomView3DFilter: ViewFilter = {
  ...baseDefaultView3DFilter,
  roofing: true,
};

export const defaultExporterView3DFilter: ViewFilter = {
  ...baseDefaultView3DFilter,
  roofing: true,
  elevationAnnotation: true,
};

export function defaultView3DFilter(): ViewFilter {
  return defaultView3DFilterInternal;
}

export const baseEstimateViewFilter3D: ViewFilter = {
  ...emptyViewFilter,
  ...internalViewFilter3DDefaults,
};

export const defaultStudioLiteView3DFilter: ViewFilter = {
  ...emptyViewFilter,
  ...internalViewFilter3DDefaults,
};

export const defaultFaceDiffView3DFilter: ViewFilter = {
  ...emptyViewFilter,
  sceneLights: true,
  faceDiff: true,
  site: false,
  grid: false,
};
